const s = "af.delete-library";
var l = ((e) => (e.Delete = "delete", e.Restore = "restore", e))(l || {});
const t = class t extends CustomEvent {
  constructor(a) {
    super(s, { detail: a, bubbles: !0, composed: !0 });
  }
};
t.EVENT_NAME = s;
let r = t;
export {
  l as DeleteLibraryEventType,
  s as EVENT_NAME,
  r as default
};
//# sourceMappingURL=DeleteLibraryEvent.js.map
